import { render, staticRenderFns } from "./Over65Years.vue?vue&type=template&id=a72aa81c&"
import script from "./Over65Years.vue?vue&type=script&lang=js&"
export * from "./Over65Years.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports